var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition,no-else-return */
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import Button from '@mui/material/Button';
import TableCell from '@mui/material/TableCell';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import DeleteIcon from '@mui/icons-material/Delete';
import ShieldIcon from '@mui/icons-material/Shield';
import TableBody from '@mui/material/TableBody';
import Typography from '@mui/material/Typography';
import { getAdmins as loadAdmins, addPlayerToMatch, createPlayer, loadPlayersInMatch, removePlayerFromMatch, setPaymentMethod, setPlayerImmunity, setWireTransferPayment, loadPayersInMatch, } from '../../../api';
import { EPaymentType } from '../../../types';
import { TableHeaderCellNew } from '../../atoms/Table/TableHeaderCell';
import { UnderLine } from '../../atoms/UnderLine';
import { TableBodyCellNew } from '../../atoms/Table/TableBodyCell';
import { Delimiter } from '../../atoms/Delimiter';
import { ModalNew } from '../../atoms/Modal/Modal';
import { AjustPlayersOrder } from '../AjustPlayersOrder/AjustPlayersOrder';
import { useAsyncExecAction } from '../../../hooks/useAsyncExecAction';
import { TableBodyRowNew } from '../../atoms/Table/TableBodyRow/TableBodyRow';
import { AlertsNew } from '../../molecules/Alerts';
import { Payment } from '../../molecules/Payment';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
const TableCellNumberHeader = styled(TableHeaderCellNew) `
  padding-left: 16px;
  width: 86px;
`;
const TableCellNameHeader = styled(TableHeaderCellNew) `
  width: 152px;
`;
const TableCellNickHeader = styled(TableHeaderCellNew) `
  width: 182px;
`;
const TableCellGamesHeader = styled(TableHeaderCellNew) `
  width: 92px;
`;
const TableCellPayHeader = styled(TableHeaderCellNew) `
  width: 188px;
  padding-right: 16px;
`;
const TBRow = styled(TableBodyRowNew) `
  font-weight: ${({ shadow }) => (shadow ? '500' : '300')};
  background: ${({ shadow }) => (shadow ? '#2AB2FF' : 'rgba(255, 255, 255, 0.1)')};
  &:nth-child(2n) {
    background: ${({ shadow }) => (shadow ? '#2AB2FF' : 'rgba(255, 255, 255, 0.2)')};
  }
`;
const TBCell = styled(TableBodyCellNew) ``;
const TableCellNumberContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const TableCellNumberBody = styled(TBCell) `
  padding-left: 16px;
  width: 86px;
`;
const TableCellNameBody = styled(TBCell) `
  width: 152px;
`;
const TableCellNickBody = styled(TBCell) `
  width: 182px;
`;
const TableCellGamesBody = styled(TBCell) `
  width: 92px;
`;
const TableCellPayBody = styled(TBCell) `
  width: 188px;
  padding-right: 16px;
`;
const Title = styled.div `
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #000;
`;
const TableHeaderContainer = styled.div `
  display: flex;
  justify-content: space-between;
`;
const TableHeader = styled.div `
  display: flex;
  align-items: center;
  min-height: 26px;
`;
// const TableBody = styled(TableBodyWithScrollNew)`
//   max-height: 45vh;
// `
const PlayerButtonImg = styled.img `
  width: 28px;
  height: 28px;
  cursor: pointer;
`;
const ShieldImg = styled.img `
  width: 12px;
  height: 14px;
  margin-right: 15px;
`;
const NoPlayersImg = styled.img `
  width: 550px;
  height: 290px;
  align-self: center;
`;
export const MatchPlayers = ({ forceAdjustWindowOpened, matchId, changed, setChanged, orderSet, setDisabled, }) => {
    const [adjustOrder, setAdjustOrder] = useState(false);
    const [players, setPlayers] = useState([]);
    const [payers, setPayers] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [previousSelectedPlayers, setPreviousSelectedPlayers] = useState([]);
    const [shieldCancel, setShieldCancel] = useState(false);
    const [playersCancel, setPlayersCancel] = useState(false);
    const [playersChanged, setPlayersChanged] = useState(false);
    const [infoAlert, setInfoAlert] = useState({ message: '', visible: false, setCancel: null });
    const { execAsyncAction } = useAsyncExecAction();
    const { errorHandler } = useErrorHandler();
    const playersAction = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield loadPlayersInMatch(matchId || '');
        setPlayers(response);
    });
    const payersAction = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield loadPayersInMatch(matchId || '');
        setPayers(response);
    });
    const getPlayers = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        execAsyncAction({ action: playersAction });
    });
    const getPayers = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        execAsyncAction({ action: payersAction });
    });
    const getAdmins = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!matchId)
            return;
        const response = yield loadAdmins(matchId || '');
        // console.log('MatchPlayers getPlayers', response)
        setAdmins(response);
    });
    const getRemovePlayerAction = (id) => function () {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield removePlayerFromMatch(id);
            // console.log('AddPlayersToMatch removePlayer', result)
        });
    };
    const removePlayer = (id) => __awaiter(void 0, void 0, void 0, function* () {
        yield execAsyncAction({ action: getRemovePlayerAction(id) });
    });
    // eslint-disable-next-line no-shadow
    const onRemovePlayerClick = (players) => __awaiter(void 0, void 0, void 0, function* () {
        // eslint-disable-next-line no-restricted-syntax
        for (const player of players) {
            // eslint-disable-next-line no-await-in-loop
            yield removePlayer(player.id);
        }
        setPreviousSelectedPlayers(players);
        setInfoAlert({ message: 'Игрок удален', visible: true, setCancel: setPlayersCancel });
        setPlayersChanged(true);
        setSelectedPlayers([]);
    });
    const addPlayer = (player) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const playerId = player.id;
            yield addPlayerToMatch({ playerId, matchId: matchId || '' });
            setPlayersChanged(true);
        }
        catch (e) {
            if (e) {
                try {
                    const response = yield createPlayer({ realName: player.player.realName, gameName: player.player.gameName });
                    yield addPlayer(response);
                }
                catch (error) {
                    console.error('AddPlayerToMatch createPlayer error', error.response);
                }
            }
        }
    });
    const getImmunityAction = (playerId, immunity) => function () {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('MatchPlayers setImmunity', response )
            yield setPlayerImmunity({ playerId, immunity });
        });
    };
    const setImmunity = (playerId, immunity) => __awaiter(void 0, void 0, void 0, function* () {
        yield execAsyncAction({ action: getImmunityAction(playerId, immunity) });
    });
    // eslint-disable-next-line no-shadow
    const onShieldClick = (players) => __awaiter(void 0, void 0, void 0, function* () {
        if (shieldCancel) {
            // eslint-disable-next-line no-restricted-syntax
            for (const player of players) {
                // eslint-disable-next-line no-await-in-loop
                yield setImmunity(player.id, player.state.immunity);
            }
            setPreviousSelectedPlayers([]);
        }
        else {
            // eslint-disable-next-line no-restricted-syntax
            for (const player of players) {
                // eslint-disable-next-line no-await-in-loop
                yield setImmunity(player.id, !player.state.immunity);
            }
            setPreviousSelectedPlayers(players);
            setInfoAlert({ message: 'Иммунитет присвоен', visible: true, setCancel: setShieldCancel });
        }
        setShieldCancel(false);
        setPlayersChanged(true);
        setSelectedPlayers([]);
    });
    const getPaymentAction = (playerId, paymentType, amount, parentPayment) => function () {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield setPaymentMethod({ playerId, paymentType, amount, parentPayment });
            setChanged(true);
        });
    };
    const changePaymentMethod = (playerId, paymentType, amount, parentPayment) => __awaiter(void 0, void 0, void 0, function* () {
        yield execAsyncAction({ action: getPaymentAction(playerId, paymentType, amount, parentPayment) });
    });
    const onPaymentSubmit = (values, actions) => __awaiter(void 0, void 0, void 0, function* () {
        if (values.paidByOtherPlayer) {
            yield changePaymentMethod(values.playerId, EPaymentType.PAID_BY_OTHER_PLAYER, values.amount, values.paymentId);
            return;
        }
        if (values.payment_method === EPaymentType.WIRE_TRANSFER) {
            yield setWireTransferPayment({
                playerId: values.playerId,
                amount: values.amount,
                administratorId: values.administratorId,
            });
        }
        else {
            yield changePaymentMethod(values.playerId, values.payment_method, values.amount, '');
        }
        actions.setSubmitting(false);
        setPlayersChanged(true);
    });
    const onPlayerRowClick = (player, e) => {
        e.stopPropagation();
        e.preventDefault();
        // console.log('MatchPlayers onPlayerRowClick', (e.target as any).tagName )
        if (e.target.tagName === 'SELECT')
            return;
        const index = selectedPlayers.indexOf(player);
        if (index >= 0) {
            selectedPlayers.splice(index, 1);
            setSelectedPlayers([...selectedPlayers]);
        }
        else {
            setSelectedPlayers([...selectedPlayers, player]);
        }
    };
    const onAjustOrderClick = () => {
        setAdjustOrder(true);
    };
    const onCloseAjustOrderClick = () => {
        orderSet();
        setAdjustOrder(false);
    };
    useEffect(() => {
        if (shieldCancel) {
            onShieldClick(previousSelectedPlayers);
        }
    }, [shieldCancel]);
    useEffect(() => {
        getPlayers();
        getPayers();
        getAdmins();
    }, [matchId]);
    useEffect(() => {
        setDisabled(selectedPlayers.length > 0);
    }, [selectedPlayers.length > 0]);
    useEffect(() => {
        if (playersCancel) {
            // eslint-disable-next-line no-restricted-syntax
            for (const player of previousSelectedPlayers) {
                addPlayer(player);
            }
        }
    }, [playersCancel]);
    useEffect(() => {
        if (playersChanged || changed) {
            getPlayers();
            setPlayersChanged(false);
            setChanged(false);
            orderSet();
        }
    }, [playersChanged, changed]);
    return (_jsxs(_Fragment, { children: [players.length ? (_jsxs(_Fragment, { children: [(adjustOrder || forceAdjustWindowOpened) && (_jsx(ModalNew, Object.assign({ onClose: onCloseAjustOrderClick, close: true }, { children: _jsx(AjustPlayersOrder, { players: players, matchId: matchId, setPlayersChanged: setPlayersChanged, onClose: onCloseAjustOrderClick }) }))), infoAlert.visible && (_jsx(AlertsNew, { message: infoAlert.message, setVisible: setInfoAlert, setCancel: infoAlert.setCancel })), _jsx(TableHeaderContainer, { children: _jsx(TableHeader, { children: selectedPlayers.length > 0 ? (_jsxs(_Fragment, { children: [_jsx(Button, { startIcon: _jsx(DeleteIcon, {}), onClick: () => onRemovePlayerClick(selectedPlayers) }), _jsx(Delimiter, { right: "5px" }), _jsx(Button, { startIcon: _jsx(ShieldIcon, {}), onClick: () => onShieldClick(selectedPlayers) })] })) : (_jsx(Button, { startIcon: _jsx(SwapVertIcon, {}), onClick: () => onAjustOrderClick() })) }) }), _jsx(Delimiter, { top: "20px" }), _jsx(TableContainer, Object.assign({ sx: { width: 700 }, component: Paper }, { children: _jsxs(Table, Object.assign({ "aria-label": "customized table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u2116" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u043C\u044F" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u043D\u0438\u043A" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041A\u043E\u043B-\u0432\u043E \u0438\u0433\u0440" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B" }))] }) }), _jsx(TableBody, { children: players === null || players === void 0 ? void 0 : players.map((player) => (_jsxs(TableRow, Object.assign({ hover: true, selected: selectedPlayers.includes(player), onClick: (e) => onPlayerRowClick(player, e) }, { children: [_jsxs(TableCell, Object.assign({ variant: "body", align: "center" }, { children: [player.positionNumber, player.state.immunity && _jsx(ShieldIcon, {})] })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.realName })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.gameName })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: player.player.gamesCount })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: _jsx(Payment, { player: player, onPaymentSubmit: onPaymentSubmit, admins: admins, players: payers.filter((p) => {
                                                        var _a, _b;
                                                        return p.id !== player.id &&
                                                            p.payment !== null &&
                                                            ((_a = p.payment) === null || _a === void 0 ? void 0 : _a.method) !== EPaymentType.PAID_BY_OTHER_PLAYER &&
                                                            ((_b = p.payment) === null || _b === void 0 ? void 0 : _b.amount) > 0;
                                                    }) }) }))] }), player.id))) })] })) })), _jsx(Delimiter, { top: "31px" })] })) : (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0418\u0433\u0440\u043E\u043A\u0438" })), _jsx(Delimiter, { top: "20px" }), _jsx(Typography, Object.assign({ sx: { width: 700 }, variant: "h4" }, { children: "\u0418\u0433\u0440\u043E\u043A\u0438 \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u044B" })), _jsx(Delimiter, { top: "1px" })] })), _jsx(UnderLine, { theme: { borderColor: 'rgba(255, 255, 255, 0.2)' } })] }));
};
